import React, { useLayoutEffect, useRef, useState } from 'react';
import { animated, useSpring } from 'react-spring';

export default function CommentWithReadMore({ content, collapsedHeight = 24 }) {
  const [expanded, setExpanded] = useState(false);
  const [fullHeight, setFullHeight] = useState(0);

  const contentRef = useRef(null);

  useLayoutEffect(() => {
    if (contentRef.current) {
      setFullHeight(contentRef.current.scrollHeight);
    }
  }, [content]);

  const animationStyles = useSpring({
    height: expanded ? fullHeight : collapsedHeight,
    config: { tension: 400, friction: 30 },
  });

  return (
    <div className='comment_content'>
      <div
        ref={contentRef}
        className='comment_content_full_text'
        dangerouslySetInnerHTML={{ __html: content }}
      />

      <animated.div
        className='comment_content comment_content_clamp_text'
        style={animationStyles}
      >
        <div dangerouslySetInnerHTML={{ __html: content }} />
      </animated.div>

      {/* Only show the button if content height is greater than the collapsed height */}
      {fullHeight > collapsedHeight && (
        <button
          className='comment_content_readmore'
          onClick={() => setExpanded(!expanded)}
        >
          {expanded ? 'Read Less' : 'Read More'}
        </button>
      )}
    </div>
  );
}
